// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3Xk3E","alert":"SettungsInbox_alert__3mXAk"};